import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './style.css'

document.documentElement.dataset.app = 'vuihoc6'
createApp(App).use(router).mount('#app')
